import { useColorModeValue } from '@chakra-ui/react';

export const CONTRACT_METHOD_FIELD_LABEL_WIDTH = { base: '100%', md: '200px' } as const;
export const CONTRACT_METHOD_FIELD_ROW_GAP = { base: 3, md: '80px' } as const;
export const CONTRACT_METHOD_FIELD_INPUT_HEIGHT = '32px';
export const CONTRACT_METHOD_FIELD_GAP = 2; // 8px between fields
export const CONTRACT_METHOD_ARRAY_ROW_GAP = 1; // 4px between array rows
export const CONTRACT_METHOD_ROW_NUMBER_WIDTH = '24px';
export const CONTRACT_METHOD_ACTION_GAP = 2; // 8px

export const CONTRACT_METHOD_ACTION_BUTTON_LOADING_PROPS = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  spinnerPlacement: 'start',
  _loading: {
    opacity: 1,
    cursor: 'not-allowed',
  },
} as const;

export function useContractMethodFieldStyles() {
  const labelColor = useColorModeValue('blackAlpha.600', '#999999');
  const inputBg = useColorModeValue('#FFFFFF', '#111111');
  const inputBorder = useColorModeValue('#E9ECEF', '#222222');
  const inputText = useColorModeValue('#000000', '#FFFFFF');
  const inputPlaceholder = useColorModeValue('#999999', '#616161');
  const selfColor = useColorModeValue('#0FA88A', '#14DCAC');
  const selfDisabledColor = useColorModeValue('blackAlpha.400', 'whiteAlpha.400');
  const brandColor = useColorModeValue('#0FA88A', '#14DCAC');
  const brandButtonText = useColorModeValue('#FFFFFF', '#000000');
  const iconColor = useColorModeValue('#1A1A1A', '#FFFFFF');
  const actionButtonBg = useColorModeValue('#FFFFFF', '#111111');
  const actionButtonBorder = useColorModeValue('#E9ECEF', '#222222');
  const actionButtonHoverBg = useColorModeValue('blackAlpha.50', 'whiteAlpha.100');
  const writeButtonBorder = useColorModeValue('#1A1A1A', '#FFFFFF');
  const writeButtonText = useColorModeValue('#1A1A1A', '#FFFFFF');
  const copyButtonBg = useColorModeValue('#FFFFFF', '#111111');
  const copyButtonBorder = useColorModeValue('#E9ECEF', '#222222');
  const copyButtonText = useColorModeValue('#999999', '#616161');
  const methodItemBg = useColorModeValue('#F6F8FA', '#151515');
  const nestedInputBg = useColorModeValue('#FFFFFF', '#171717');

  return {
    labelColor,
    inputBg,
    inputBorder,
    inputText,
    inputPlaceholder,
    selfColor,
    selfDisabledColor,
    brandColor,
    brandButtonText,
    iconColor,
    actionButtonBg,
    actionButtonBorder,
    actionButtonHoverBg,
    writeButtonBorder,
    writeButtonText,
    copyButtonBg,
    copyButtonBorder,
    copyButtonText,
    methodItemBg,
    nestedInputBg,
  };
}
